// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3heiZ","productName":"Table_productName__2XDxy"};